<template>
    <div class="node_register">
        <div class="bread_crumb">
            业务管理 > 节点注册
        </div>
        <div class="main">
            <div class="top">
                <div class="left">
                    <span>节点注册</span>
                    <span>Node Registration</span>
                </div>
                <div class="right">
                    <label>业务区域：</label>
                    <el-select  v-model="provinceCode" placeholder="请选择省" @change="selectProvince" class="mr20" style="width:150px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in provinceCodeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="cityCode" placeholder="请选择市" class="mr20" style="width:150px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in cityCodeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-select v-model="areaCode" placeholder="请选择县" style="width:150px;" class="mr20">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in areaCodeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select> -->
                    <el-input v-model="ruleForm.keywords" placeholder="请输入节点编码或节点名称" class="mr20" style="width:280px;"></el-input>
                    <el-button size="medium" class="mr20 pub_green_btn" @click="applylist()">搜索</el-button>
                    <el-button size="medium" @click="nodeDialog=true">节点注册</el-button>
                </div>
            </div>
            <div class="table_list">
                <div class="table_wrap">
                    <el-table
                        border
                        class="table_data"
                        :data="tableData"
                        style="width: 100%">
                        <el-table-column prop="nodeName" label="节点名称" min-width="180" align="center"></el-table-column>
                        <el-table-column prop="nodeProfile" label="节点简介" min-width="280" align="center"></el-table-column>
                        <!-- <el-table-column prop="nodeIdcode" label="节点编码" min-width="180" align="center"></el-table-column> -->
                        <el-table-column prop="area" label="地区" min-width="180" align="center"></el-table-column>
                        <el-table-column prop="linkman" label="联系人" width="100" align="center"></el-table-column>
                        <el-table-column prop="state" label="状态" width="130" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.state==-1" class="circle red">审核不通过</span>
                                <span v-else-if="scope.row.state==0" class="circle grey">待一审</span>
                                <span v-else-if="scope.row.state==1" class="circle grey">待二审</span>
                                <span v-else-if="scope.row.state==2" class="circle grey">待三审</span>
                                <span v-else-if="scope.row.state==100" class="circle green">审核通过</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="addTime" label="创建时间" min-width="180" align="center"></el-table-column>
                        <el-table-column label="操作" width="250" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="nodeApplyDetail(scope.row)">详情</el-button>
                                <el-button v-if="scope.row.state!=100" size="mini" @click="edit(scope.row)">编辑</el-button>
                                <el-button v-if="scope.row.state!=100" size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        class="laypage_list"
                        @current-change="currChange"
                        :page-size="ruleForm.limit"
                        :current-page="ruleForm.page"
                        background
                        layout="prev, pager, next,total"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 节点注册弹框 -->
        <el-dialog
            title="节点注册"
            :visible.sync="nodeDialog"
			:before-close= "closeNode"
            width="50%">
            <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="100px" class="form_dialog">
                <el-form-item label="节点名称：" prop="nodeName">
                    <el-input v-model="registerForm.nodeName" placeholder="请输入节点名称"></el-input>
                </el-form-item>
				<el-form-item label="节点简介：" prop="nodeProfile">
				    <el-input type="textarea" :rows="4" v-model="registerForm.nodeProfile" placeholder="请输入节点简介"></el-input>
				</el-form-item>
				<el-form-item label="业务区域：" prop="provinceCode">
					<el-select v-model="registerForm.provinceCode" placeholder="请选择省份" style="width:150px;float: left;" class="mr10"  @change="provinceChange">
						<el-option
						  v-for="item in provinceArr"
						  :key="item.id"
						  :label="item.name"
						  :value="item.id">
						</el-option>
					</el-select>
					<el-form-item  prop="cityCode" style="float: left;">
						<el-select v-model="registerForm.cityCode" placeholder="请选择市" class="mr10" style="width:150px;" @change="cityChange">
						    <!-- <el-option label="全部" value=""></el-option> -->
						    <el-option v-for="item in cityArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item  prop="areaCode" style="float: left;">
						<el-select v-model="registerForm.areaCode" placeholder="请选择县" style="width:150px;" >
						    <!-- <el-option label="全部" value=""></el-option> -->
						    <el-option v-for="item in areaArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-form-item>
				<el-form-item label="合同协议：" prop="contractAgreement">
					<el-upload
					  action=""
					  :on-remove="handleRemove"
					  :on-exceed="beyond"
					  :limit="1"
					  :file-list="fileList"
				:before-upload="beforeUpload"
					  accept=".doc,.pdf,.docx"
					  :http-request="httpUpload"
					 >
					  <el-button size="small" type="primary">点击上传</el-button>
					  <div slot="tip" class="el-upload__tip">只能上传doc/docs/pdf文件</div>
					</el-upload>
				</el-form-item>
                <div class="btn_wrap">
                    <el-button class="pub_green_btn" @click="applycreate">提交申请</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!-- 节点详情弹框 -->
        <el-dialog
            title="节点详情"
            :visible.sync="detailDialog"
            width="50%">
            <div class="form_dialog node_detail_dialog">
                <ul class="list">
                    <li>
                        <label>节点名称：</label>
                        <span>{{detailObj.nodeName||''}}</span>
                    </li>
					<li>
					    <label>节点简介：</label>
					    <span>{{detailObj.nodeProfile||''}}</span>
					</li>
                    <li>
                        <label>单位名称：</label>
                        <span>{{detailObj.unitName||''}}</span>
                    </li>
                    <li>
                        <label>统一社会信用代码：</label>
                        <span>{{detailObj.unitCode||''}}</span>
                    </li>
                    <li>
                        <label>注册地址：</label>
                        <span>{{detailObj.unitAddress||''}}</span>
                    </li>
                    <li class="img_wrap">
                        <label>营业执照：</label>
                        <el-image 
                            :z-index="3000"
                            :src="detailObj.license"
                            :preview-src-list="srcList">
                        </el-image>
                        <!-- <img :src="detailObj.license" alt=""> -->
                        <!-- <el-button class="look_img" size="mini" round>查看原图</el-button> -->
                    </li>
                     <li>
                        <label>联系人：</label>
                        <span>{{detailObj.linkman||''}}</span>
                    </li>
                     <li>
                        <label>手机：</label>
                        <span>{{detailObj.linkphone||''}}</span>
                    </li>
                     <li>
                        <label>电子邮箱：</label>
                        <span>{{detailObj.email||''}}</span>
                    </li>
                </ul>
                <div class="btn_wrap">
                    <el-button class="pub_green_btn" @click="detailDialog=false">关闭</el-button>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog = false">取 消</el-button>
                <el-button type="primary" @click="editDialog = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
    import {address, uploadFile} from '@/api/home'
    import {applylist,applycreate,applyupdate,nodeApplyDelete} from '@/api/admin'
export default {
    name:'NodeRegister',
    data() {
      return {
		  provinceArr: [],
		  cityArr: [],
		  areaArr: [],
		  fileList: [],
		  imgUrl: [],
        provinceCodeData: [],//所属省
        cityCodeData: [],//所属市
        // areaCodeData: [],//所属区县
        provinceName:'',//所属省名称
        provinceCode:'',//所属省代码
        cityName:'',//所属市名称
        cityCode:'',//所属市代码
        // areaName:'',//所属区县名称
        // areaCode:'',//所属区县代码
        ruleForm: {
          area: '',//行政区划ID
          keywords: '',//模糊查询
          page: 1,//页码
          limit: 10,//分页大小
        },
        rules: {
          nodeName: [
            { required: true, message: '节点名称不能为空', trigger: 'blur' },
          ],
		  provinceCode: [
			  { required: true, message: '请选择省份', trigger: 'change' },
		  ],
		  contractAgreement: [
			  { required: true, message: '请上传合同协议', trigger: 'upload' },
		  ],
		  nodeProfile: [
            { required: true, message: '节点简介不能为空', trigger: 'blur' },
          ],
        },
        tableData: [],//列表
        total:0,//总条数

        nodeDialog:false,//节点注册弹框
        registerForm:{
            id:'',//id
            nodeName:'',//节点名称
			nodeProfile: '',
			provinceCode: undefined,
			cityCode: undefined,
			areaCode: undefined,
			contractAgreement: ''
        },

        detailDialog:false,//节点详情弹框
        detailObj:{},//节点详情
        srcList: []
      }
    },
    mounted(){
        this.address()
        this.applylist()
    },
    methods:{
        address(){//获取行政区划列表
            address({}).then(res=>{
                // console.log('获取行政区划列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.provinceCodeData=res.data||[]
				this.provinceArr=res.data||[]
            })
        },
        applylist(val){//节点申请列表
            // if (this.areaCode) {
            //     this.ruleForm.area=this.areaCode
            // }else{
            if (this.cityCode) {
                this.ruleForm.area=this.cityCode
            }else{
                if (this.provinceCode) {
                    this.ruleForm.area=this.provinceCode
                }else{
                    this.ruleForm.area=''
                }
            }
            // }
            this.ruleForm.page=val||1
            applylist(this.ruleForm).then(res=>{
                // console.log('节点申请列表')
                // console.log(JSON.parse(JSON.stringify(res.data)))
                this.tableData=res.data.list||[]
				if(this.tableData.length > 0) {
					this.tableData.forEach(function(item,index){
						if(item.provinceName) {
							item.area = item.provinceName
						}
						if(item.cityName) {
							item.area += '-' + item.cityName
						}
						if(item.areaName) {
							item.area += '-' + item.areaName
						}
					})
				}
                this.total=res.data.total
				setTimeout(function(){
				  var elems = document.querySelectorAll('.el-table--enable-row-transition .el-table__body td .cell')
				  elems.forEach(function(item,index){
				    item.className = 'cell cell2'
				  })
				},1)
            }).catch(()=>{
                this.tableData=[]
                this.total=0
            })
        },
        applycreate(val){//添加节点申请
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '拼命加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let api=this.registerForm.id?applyupdate:applycreate
                    api(this.registerForm).then(res=>{
                        this.$message({
                            message: res.errmsg,
                            type: 'success',
                            duration: '2000',
                            onClose:()=>{
                                this.applylist()
								this.$nextTick(()=>{
									this.$refs['registerForm'].clearValidate()
									this.$refs['registerForm'].resetFields()
									this.fileList = []
									this.imgUrl = []
								})
                                loading.close()
                                this.nodeDialog=false
                            }
                        });
                    }).catch(()=>{
                        loading.close()
                    })
                } else {
                    return false;
                }
            });
        },
        edit(v){//编辑
		this.fileList = []
		// this.imgUrl = []
            for (const key in this.registerForm) {
                this.registerForm[key]=v[key]
				this.registerForm.provinceCode = parseInt(this.registerForm.provinceCode)
				for (let i = 0; i < this.provinceArr.length; i++) {
				    if (this.registerForm.provinceCode==this.provinceArr[i].id) {
				        this.cityArr=this.provinceArr[i].children
				        break
				    }
				}
				this.registerForm.cityCode = this.registerForm.cityCode?parseInt(this.registerForm.cityCode):undefined
				for (let i = 0; i < this.cityArr.length; i++) {
				    if (this.registerForm.cityCode==this.cityArr[i].id) {
				        this.areaArr=this.cityArr[i].children
				        break
				    }
				}
				this.registerForm.areaCode = this.registerForm.areaCode?parseInt(this.registerForm.areaCode):this.registerForm.areaCode
            }
			if(this.registerForm.contractAgreement) {
				var arr = this.registerForm.contractAgreement.split('/')
				var len = arr.length
				this.fileList.push({
				  name: arr[len-1],
				  url: this.registerForm.contractAgreement
				})
			}
			
            this.nodeDialog=true
        },
        closeNode(){//关闭节点注册弹框
            // console.log('关闭节点注册弹框')
            // this.$refs.registerForm.resetFields();
			this.$nextTick(()=>{
				this.registerForm.id=''
				this.$refs['registerForm'].clearValidate()
				this.$refs['registerForm'].resetFields()
				// this.$refs.registerForm.resetFields();
				// this.$refs.registerForm.clearValidate();
				// console.log(this.$refs['registerForm'])
				console.log(this.registerForm)
				console.log(this.$refs['registerForm'])
				this.fileList = []
			})
			this.nodeDialog=false
        },
        selectProvince(val){//选择省
            if (val) {
                for (let i = 0; i < this.provinceCodeData.length; i++) {
                    if (val==this.provinceCodeData[i].id) {
                        this.cityCodeData=this.provinceCodeData[i].children
                        break
                    }
                }
            }else{
                this.cityCodeData=[]
            }
            this.cityCode=''
            // this.areaCode=''
            // this.areaCodeData=[]
        },
        // selectCity(val){//选择市
        //     if (val) {
        //         for (let i = 0; i < this.cityCodeData.length; i++) {
        //             if (val==this.cityCodeData[i].id) {
        //                 this.areaCodeData=this.cityCodeData[i].children
        //                 break
        //             }
        //         }
        //         this.areaCode=''
        //     }else{
        //         this.areaCodeData=[]
        //     }
        //     this.areaCode=''
        // },
        currChange(val){//页码变化
            this.applylist(val)
        },
        nodeApplyDetail(v){//节点申请详情
            // console.log('节点申请详情')
            // console.log(JSON.parse(JSON.stringify(v)))
            this.srcList[0]=v.license||[]
            this.detailObj=v
            this.detailDialog=true
        },
        del(v){//删除
            this.$confirm('确定要删除吗?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                nodeApplyDelete({
                    id:v.id
                }).then(res=>{
					if(res.errno == 0) {
						this.$message({
						    type: 'success',
						    message: res.errmsg,
						    duration: 2000,
						    onClose:()=>{
						    }
						});
						this.applylist()
					}
                    
                })
            }).catch(() => {});
        },
		provinceChange(val) {	//	选择业务区域
			if (val) {
			    for (let i = 0; i < this.provinceArr.length; i++) {
			        if (val==this.provinceArr[i].id) {
			            this.cityArr=this.provinceArr[i].children
			            break
			        }
			    }
			}else{
			    this.cityArr=[]
			}
			this.registerForm.cityCode=''
			this.registerForm.areaCode=''
			this.areaArr=[]
		},
		cityChange(val) {	//	选择业务区域
			if (val) {
			    for (let i = 0; i < this.cityArr.length; i++) {
			        if (val==this.cityArr[i].id) {
			            this.areaArr=this.cityArr[i].children
			            break
			        }
			    }
			}else{
			    this.areaArr=[]
			}
			this.registerForm.areaCode=''
		},
		// 图片上传前
		beforeUpload(file) {
			console.log('121');
			console.log(file)
			var type = file.name.split('.');
			var size = 5 * 1024 * 1024;
			console.log(file.size > size);
		// .doc,.pdf,.docx
		if (!type.includes('doc') && !type.includes('pdf')&& !type.includes('docx')) {
			this.$message({
				message: '只能上传.doc.pdf,.docx的文件',
				type: 'warning'
			});
			return false;
		} else
			// if (!type.includes('png') && !type.includes('jpg')) {
			// 	this.$message({
			// 		message: '只能上传png/jpg的图片',
			// 		type: 'warning'
			// 	});
			// 	return false;
			// } else
		   if (file.size > size) {
				this.$message({
					message: '文件大小不能超过5M',
					type: 'warning'
				});
				return false;
			}
		},
		// 图片数量超出提示
		beyond(files, fileList) {
			if (fileList.length >= 1) {
				this.$message({
					message: '上传文件数量已达到上限',
					type: 'warning'
				});
				return;
			}
		},
		// 自定义上传行为
		httpUpload(params) {
			console.log('文件');
			console.log(params);
			let file = params.file;
		  // console.log(file.type)
		  var type = file.type
		  // if (['application/pdf'].indexOf(file.raw.type) == -1 || ) {
		  //     this.$message.error('请上传正确的pdf格式');
		  //     return false;
		  // }
			var data = new FormData();
			data.append('file', file);
			uploadFile(data)
				.then(res => {
					console.log(res, '文件上传');
					if (res.errno == 0) {
						this.imgUrl.push(res.data.url);
						this.registerForm.contractAgreement = this.imgUrl.toString();
						this.$message({
							message: res.errmsg,
							type: 'success'
						});
					} else {
						this.$message({
							message: res.errmsg,
							type: 'error'
						});
					}
		
					this.$forceUpdate();
					console.log(this.fileList, '数据');
				})
				.catch(() => {});
		},
		//  删除图片
		handleRemove(file) {
			const imgUrl = file.url;
			// 2.从pics数组中，找到图片对应的索引值
			const i = this.imgUrl.findIndex(x => x === imgUrl);
			// 3.调用splice方法，移除图片信息
			this.imgUrl.splice(i, 1);
			this.registerForm.contractAgreement = this.imgUrl.toString();
		},
    }
}
</script>

<style>
	.cell2 {
	  display: -webkit-box;
	    word-break: break-all !important;
	    -webkit-box-orient: vertical;
	    -webkit-line-clamp: 3;
	    overflow: hidden;
	    text-overflow: ellipsis;
	}
</style>
<style lang='scss' scoped>
    .node_register{
        // border: 1px solid #f00;
        // box-sizing: border-box;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .mr20{
            margin-right: 20px;
        }
		.mr10{
		    margin-right: 10px;
		}
        .bread_crumb{
            flex: none;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
        .main{
            overflow-x: hidden;
            flex: 1;
            background-color: #fff;
            border-radius: 10px;
            margin-top: 20px;
            padding: 40px 50px;
            box-sizing: border-box;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            .top{
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #E6E6E6;
                padding-bottom: 30px;
                .left{

                    span:nth-child(1){
                        font-size: 20px;
                        font-weight: 600;
                        color: #00AA73;
                    }
                    span:nth-child(2){
                        font-size: 16px;
                        font-weight: 400;
                        color: #808080;
                        margin-left: 6px;
                        white-space: nowrap;
                        word-break:break-all;
                    }
                }
                .right{
                    display: flex;
                    align-items: center;
					justify-content: flex-end;
					flex: 1;
					width: 0;
                    label{
                        flex: none;
                    }
                    .el-button{
                        border: 2px solid #00AA73;
                        width: 115px;
                        // height: 40px;
                        font-size: 16px;
                        // margin-right: 60px;
                        font-weight: 700;
                        color: #00AA73;
                    }
                }
            }
            .table_list{
                flex-grow: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                .table_wrap{
                    max-height:100%;
                    .table_data{
                        border: 1px solid #EBEEF5;
                        height: calc(100% - 54px);
                        ::v-deep {.el-table__body-wrapper{
                            overflow-y: auto;
                            height: calc(100% - 46px);
                        }
                    }
                        .circle{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            &::before{
                                display: inline-block;
                                content: '';
                                width: 14px;
                                height: 14px;
                                border-radius: 50%;
                                margin-right: 5px;
                            }
                        }
                        .grey{
                            &::before{
                                background-color: #BDBDBD;
                            }
                        }
                        .green{
                            &::before{
                                background-color: #00AA73;
                            }
                        }
                        .red{
                            &::before{
                                background-color: #FF4D4F;
                            }
                        }
                    }
                    .laypage_list{
                        text-align: right;
                        margin-top: 20px;
                    }
                }
            }
        }
        .form_dialog{
            border-top: 1px solid #E6E6E6;
            padding-top: 40px;
            .btn_wrap{
                text-align: center;
                margin-top: 50px;
            }
        }
        .node_detail_dialog{
            .list{
                // border: 1px solid #f00;
                >li{
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    label{
                        flex: none;
                        font-size: 16px;
                        color: #333;
                        display: inline-block;
                        width: 150px;
                        // border: 1px solid #0f0;
                        text-align: right;
                        font-weight: 500;
                    }
                    span{
                        flex: 1;
                        font-size: 16px;
                        color: #666;
                        margin-left: 10px;
                        // border: 1px solid #f0f;
                    }
                }
                .img_wrap{
                    // border: 1px solid #f0f;
                    display: flex;
                    align-items: start;
                    .el-image{
                        // border: 1px solid #0f0;
                        max-width: 357px;
                        // max-height: 255px;
                        margin-left: 10px;
                    }
                    .look_img{
                        font-size: 12px;
                        color: #999;
                        margin-left: 20px;
                    }
                }
            }
            .btn_wrap{
                margin-top: 0;
                .pub_green_btn{
                    width: 135px;
                }
            }
        }
        ::v-deep {.el-dialog__body{
            padding: 20px 50px 40px;
            box-sizing: border-box;
        }
    }
    ::v-deep {.el-dialog__header{
            text-align: center;
            font-weight: 600;
        }
    }
    }
</style>